function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#748499"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.934 11.813l4.08 4.08a8.28 8.28 0 006.56-5.493L9.12 3.947l-4.186 7.866z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.445 11.547c-.438-2.294-.97-3.2-2.318-3.467.627-.533 1.065-1.413 1.065-2.187 0-1.2-.501-2.16-2.192-2.16-1.692 0-2.193.96-2.193 2.16 0 .774.438 1.68 1.065 2.187-1.347.267-1.848 1.173-2.318 3.467-.157.72.626.72.626.72h5.639c.03 0 .783 0 .626-.72z",
  fill: "#E4E7EC"
});

function SvgEnrolledAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "enrolled-avatar-c4820d4c2851026c7ed9f7c39cfa22a3.svg";
export { SvgEnrolledAvatar as ReactComponent };